import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import LandingHeader from '../components/landing/LandingHeader';
import LandingJumbotron from '../components/landing/LandingJumbotron';
import LandingFeatures from '../components/landing/LandingFeatures';
import LandingCustomers from '../components/landing/LandingCustomers';
import LandingViewerFeedback from '../components/landing/LandingViewerFeedback';
import GetStarted from '../components/landing/GetStarted';
import LandingFooter from '../components/landing/LandingFooter';
import DestinationPrompt from './DestinationPrompt';
import FadeIn from '../components/global/FadeIn';
import * as actions from '../redux/actions';

import '../static/landing/Landing.css';
import '../static/landing/LandingHeader.css';
import '../static/landing/LandingJumbotron.css';
import '../static/landing/LandingFeatures.css';
import '../static/landing/LandingCustomers.css';
import '../static/landing/LandingViewerFeedback.css';
import '../static/landing/GetStarted.css';
import '../static/landing/LandingFooter.css';
const DESTINATION_PROMPT = 'destinationPrompt';
const LANDING = 'landing';

class Landing extends Component {

	constructor(props) {
		super(props);
		const showLanding = false; // this.getCookie('show_landing');
		
		this.state = {
			renderState: showLanding ? LANDING : DESTINATION_PROMPT
		};
	}

	componentDidMount() {
		window.$('body').animate({ scrollTop: 0 }, 0);
	}

	setCookie = (cname, cvalue, exdays) => {
		let d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	getCookie = (cname) => {
		let name = cname + "=";
		let decodedCookie = decodeURIComponent(document.cookie);
		let ca = decodedCookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	updateRenderState(renderState) {
		this.setState({ renderState });
	}

	render() {
		if (this.state.renderState === DESTINATION_PROMPT) {
			return <DestinationPrompt history={this.props.history} updateRenderState={this.updateRenderState.bind(this)} setCookie={this.setCookie} />;
		}

		return (
			<FadeIn>
				<Fragment>
					<LandingHeader history={this.props.history} />
					<LandingJumbotron setCookie={this.setCookie} getCookie={this.getCookie} {...this.props} />
					<LandingFeatures />
					<LandingCustomers />
					<LandingViewerFeedback />
					<GetStarted />
					<LandingFooter />
				</Fragment>
			</FadeIn>
		);
	}

}

const mapStateToProps = state => ({
	currentUser: state.currentUser.currentUser,
});

export default connect(mapStateToProps, actions)(Landing);




// WEBPACK FOOTER //
// ./src/pages/Landing.js